import { ContactResult } from 'utils/enums'

export const destinationProviderItems = (provider, temporaryProvider, i18n) => {
	return [
		{
			title: temporaryProvider
				? i18n`${temporaryProvider?.name} (Temporary)`
				: provider?.name,
			icon: 'location-alt',
		},
	]
}

export const callHistoryItems = (contactAttempts) => {
	return (contactAttempts || []).map(({ date, success }) => ({
		status: success ? 'success' : 'call-missed',
		icon: success ? 'next' : 'call_missed',
		date: {
			shortDateFormat: date.shortDateFormat,
			shortTimeFormat: date.shortTimeFormat,
		},
	}))
}

export const contactItems = (contactData, i18n, data) => {
	return [
		{
			title: i18n`Do you wish to contact the victim?`,
			text: contactData.makeContact ? i18n`Yes` : i18n`No`,
		},
		!contactData.makeContact && {
			title: i18n`Reason`,
			text: contactData.noContactReason?.description,
		},
		contactData.noContactReason?.description === 'Outro' && {
			title: i18n`Reason Description`,
			text: data.noReasonContact,
		},
		contactData.makeContact && {
			title: i18n`Was the contact attempt successful?`,
			text: contactData.contactResult?.description,
		},
		contactData.contactResult?.id === ContactResult.Success && {
			title: i18n`Is call recording authorized?`,
			text: contactData.allowCall ? i18n`Yes` : i18n`No`,
		},
	].filter((f) => f)
}

export const injuredItems = (
	injuredInfo,
	isAllianzInsuranceCompany,
	clubName,
	i18n
) => {
	return [
		{
			title: i18n`Email`,
			text: injuredInfo?.email || i18n`Not defined`,
		},
		{
			title: i18n`NIF`,
			text: injuredInfo?.nif || i18n`Not defined`,
		},
		/*isAllianzInsuranceCompany && {
			title: i18n`Club`,
			text: clubName || i18n`Not defined`,
		},
		*/
	].filter(Boolean)
}

export const dataValidationItems = (dataValidation, process, i18n) => {
	return [
		{
			title: i18n`Injured name`,
			text: dataValidation.injuredName.validation
				? process.injured?.name
				: dataValidation.injuredName.value || process.injured?.name,
			icon: dataValidation.injuredName.validation ? 'check' : 'cross-alt',
		},
		{
			title: i18n`Postal code`,
			text: dataValidation.postalCode?.validation
				? process.injured.postalCode || i18n`Not defined`
				: dataValidation.postalCode?.value || i18n`Not defined`,
			icon: dataValidation.postalCode?.validation ? 'check' : 'cross-alt',
		},
		/*{
			title: i18n`Accident site`,
			text: dataValidation.accidentSite.validation
				? process.accident.local || i18n`Not defined`
				: dataValidation.accidentSite?.value?.description || '',
			icon: dataValidation.accidentSite.validation
				? 'check'
				: 'cross-alt',
		},

		 */
		/*{
			title: i18n`Accident description`,
			text: dataValidation.accidentDescription.validation
				? process.accident.description
				: dataValidation.accidentDescription.value,
			icon: dataValidation.accidentDescription.validation
				? 'check'
				: 'cross-alt',
		},
		*/
	]
}

export const bodyPartItems = (injury, i18n) => {
	return [
		/*{
			title: i18n`Injury Type`,
			text: injury.type?.name || i18n`Not defined`,
		},
		 */
		{
			title: i18n`Body Part`,
			text: injury.bodyPart || i18n`Not defined`,
		},
	]
}

export const clinicalAssistanceItems = (
	medicalAssistanceInfo,
	process,
	i18n
) => {
	const segment = process?.accident?.segment?.abbreviation

	let items = [
		{
			title: i18n`Did the injured had medical assistance?`,
			text: medicalAssistanceInfo.hospital ? i18n`Yes` : i18n`No`,
		},
	]

	if (medicalAssistanceInfo.hospital) {
		items = [
			...items,
			/*	{
				title: i18n`Place`,
				text: medicalAssistanceInfo.hospitalName,
			},
			{
				title: i18n`Date`,
				text: medicalAssistanceInfo.hospitalDate?.shortDateFormat,
			},
		 */
			/*			{
				title: i18n`Injured hospitalized?`,
				text: medicalAssistanceInfo.hospitalized ? i18n`Yes` : i18n`No`,
			},*/
		]

		if (medicalAssistanceInfo.hospitalized) {
			items = [
				...items,
				{
					title: i18n`Reason for hospitalization`,
					text: medicalAssistanceInfo.hospitalizationReason
						?.description,
				},
				medicalAssistanceInfo.hospitalizationReason?.description ===
					'Outro' && {
					title: i18n`Other reason for hospitalization`,
					text: medicalAssistanceInfo.hospitalizationOtherReason,
				},
				{
					title: i18n`Service`,
					text: medicalAssistanceInfo.hospitalizationService,
				},
				{
					title: i18n`Floor`,
					text: medicalAssistanceInfo.hospitalizationFloor,
				},
				{
					title: i18n`Bed`,
					text: medicalAssistanceInfo.hospitalizationBed,
				},
				{
					title: i18n`Has a discharge forecast?`,
					text: medicalAssistanceInfo.dischargeForecast
						? i18n`Yes`
						: i18n`No`,
				},
				medicalAssistanceInfo.dischargeForecast && {
					title: i18n`Discharge date`,
					text: medicalAssistanceInfo.dischargeForecastDate
						?.shortDateFormat,
				},
			].filter((f) => f)
		}

		items = [
			...items,
			/*			!medicalAssistanceInfo.hospitalized && {
				title: i18n`Had any surgery because of the accident?`,
				text: medicalAssistanceInfo.hadSurgery ? i18n`Yes` : i18n`No`,
			},*/
			medicalAssistanceInfo.hadSurgery && {
				title: i18n`Surgery description`,
				text: medicalAssistanceInfo.surgery,
			},
		].filter((f) => f)
	}

	/*	items = [
		...items,
		medicalAssistanceInfo.hospital && {
			title: i18n`Clinical documentation attached?`,
			text: medicalAssistanceInfo.hasClinicalDocs ? i18n`Yes` : i18n`No`,
		},
	].filter((f) => f)

 */

	if (medicalAssistanceInfo.hospital) {
		if (!medicalAssistanceInfo.hospitalized) {
			items = [
				...items,
				!medicalAssistanceInfo.hasMedicalDischarge && {
					title:
						segment === 'AD'
							? i18n`Had the need of stop doing sports?`
							: i18n`Had the need of stop working?`,
					text: medicalAssistanceInfo.canWork ? i18n`Yes` : i18n`No`,
				},
				/*				medicalAssistanceInfo.canWork && {
					title: i18n`Since`,
					text: medicalAssistanceInfo.workDisabilityStartDate
						?.shortDateFormat,
				},
				medicalAssistanceInfo.canWork && {
					title: i18n`Until`,
					text: medicalAssistanceInfo.workDisabilityEndDate
						.shortDateFormat
						? medicalAssistanceInfo.workDisabilityEndDate
								?.shortDateFormat
						: i18n`Present`,
				},*/
			].filter((f) => f)
		}
	} else {
		items = [
			...items,
			{
				title:
					segment === 'AD'
						? i18n`Had the need of stop doing sports?`
						: i18n`Had the need of stop working?`,
				text: medicalAssistanceInfo.canWork ? i18n`Yes` : i18n`No`,
			},
			/*			medicalAssistanceInfo.canWork && {
				title: i18n`Since`,
				text: medicalAssistanceInfo.workDisabilityStartDate
					?.shortDateFormat,
			},
			medicalAssistanceInfo.canWork && {
				title: i18n`Until`,
				text: medicalAssistanceInfo.workDisabilityEndDate
					.shortDateFormat
					? medicalAssistanceInfo.workDisabilityEndDate
							?.shortDateFormat
					: i18n`Present`,
			},*/
		].filter((f) => f)
	}

	return items
}

export const followUpNetworkItems = (followUpNetwork, i18n) => {
	return [
		{
			title: i18n`Follow up on Trust network?`,
			text: followUpNetwork.followUpTrustNetwork ? i18n`Yes` : i18n`No`,
		},
		!followUpNetwork.followUpTrustNetwork && {
			title: i18n`Reason`,
			text: followUpNetwork.outsideNetworkReason?.description,
		},
		followUpNetwork.outsideNetworkReason?.description === 'Outro' && {
			title: i18n`Which?`,
			text: followUpNetwork.otherOutsideNetworkReason,
		},
	].filter((f) => f)
}
